import { defaultExplorerState, type ExplorerState } from '../../discovery'

// clearState returns a fresh default ExplorerState.
// Design choice: rather than accepting a setter (which would couple this
// function to React state mechanics), we return a plain value and let the
// caller do setState(clearState()). This mirrors the Rust signature intent —
// resetting to default — while staying idiomatic in TypeScript.
export function clearState(): ExplorerState {
  return defaultExplorerState()
}

export function statusLabel(status: string): string {
  switch (status) {
    case 'en-tramitacion':
      return 'En tramitación'
    case 'publicado':
      return 'Publicado'
    default:
      return status
  }
}

export function chamberLabel(chamber: string): string {
  switch (chamber) {
    case 'senado':
      return 'Senado'
    case 'diputados':
      return 'Cámara de Diputados'
    default:
      return chamber
  }
}
